export default __webpack_public_path__ + "static/media/gothenburg_background_m1.80478a22.jpg";